<div class="pt-4 mb-6">
  <h2 *ngIf="calendarDataLoading"
      class="text-muted calendar-indicator">
    Loading...
  </h2>
  <h2 *ngIf="serverError"
      class="calendar-indicator">
    Server Error: {{ serverError }}
  </h2>

  <div class="clearfix mb-2">
    <button class="btn btn-sm btn-outline-primary float-left mb-2 mr-2"
            style="height: 33px"
            role="button"
            [disabled]="loadingFiltersModalRequirements()"
            [class.disabled]="loadingFiltersModalRequirements()"
            (click)="openEditFiltersModal()">
      {{ loadingFiltersModalRequirements() ? 'Loading...' : 'Edit Filters' }}
    </button>
    <span *ngFor="let activeFilter of getActiveFilters()"
          class="filter-item mb-2 mr-2 cursor-pointer"
          (click)="openEditFiltersModal()">{{ activeFilter }}</span>
    <span class="filter-item mb-2 mr-2 float-right">
      Your time zone is {{ getTimeZoneDisplayName(getBrowserTimeZone()) }}
    </span>
  </div>

  <full-calendar #calendar [options]="calendarOptions"></full-calendar>
</div>
